import { render } from "./MissingShipments.vue?vue&type=template&id=66e5eb1a&scoped=true"
import script from "./MissingShipments.vue?vue&type=script&lang=js"
export * from "./MissingShipments.vue?vue&type=script&lang=js"

import "./MissingShipments.vue?vue&type=style&index=0&id=66e5eb1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e5eb1a"]])

export default __exports__